import React from 'react';
import {useStyles} from "../TopupProducts.style";
import clsx from "clsx";
import TopupProductRowProperties from "./TopupProductsRowProperties";
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import ShowProduct from '../../../shared_components/Info/ShowProduct/ShowProduct';
import ShowProductEnable from '../../../shared_components/Info/ShowProductEnable/ShowProductEnable';
import EditTopupProductEnableButton from '../../../shared_components/Buttons/EditTopupProductEnableButton/EditTopupProductEnableButton';

const TopupProductRowSmall: React.FC<TopupProductRowProperties> = ({topupProduct, onUpdate}) => {

    const classes = useStyles();


    return (
        <div className={clsx(classes.topup_price_info_container_small)}>
            <ShowProduct value={topupProduct ?? undefined}/>
            <ShowProductEnable value={topupProduct ?? undefined}/>
            <div className={classes.menu_container_small}>
                    <EditTopupProductEnableButton
                       size={ButtonSize.SMALL}
                       onSave={onUpdate}
                       showText
                       topupProductId={topupProduct?.id}
                       type={ButtonType.SECONDARY}
                   />
            </div>
        </div>
    )
}

export default TopupProductRowSmall;
